export default {
  setShopLinks: (state, payload) => {
    state.shopLinks = payload;
  },
  removeShopLink: (state, payload) => {
    state.shopLinks.splice(payload, 1);
  },
  setLoadingLinks: (state, payload) => {
    state.loadingLinks = payload;
  },
};
